import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';

export default function SaveButton({ onClick, saving = false, label, savingLabel, savedLabel, disabled = false, variant = 'contained', color = 'primary', fullWidth = false, sx = {} }) {
  const { t } = useTranslation();
  const _label = label || t('common.save');
  const _savingLabel = savingLabel || t('common.saving');
  const _savedLabel = savedLabel || t('common.saved');
  const [showCheck, setShowCheck] = useState(false);
  const [wasSaving, setWasSaving] = useState(false);

  useEffect(() => {
    if (wasSaving && !saving) {
      setShowCheck(true);
      const timer = setTimeout(() => setShowCheck(false), 1500);
      return () => clearTimeout(timer);
    }
    setWasSaving(saving);
  }, [saving, wasSaving]);

  const startIcon = saving
    ? <CircularProgress size={20} color="inherit" />
    : showCheck
      ? <CheckIcon />
      : null;

  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={showCheck ? 'success' : color}
      disabled={disabled || saving}
      fullWidth={fullWidth}
      startIcon={startIcon}
      sx={sx}
    >
      {saving ? _savingLabel : showCheck ? _savedLabel : _label}
    </Button>
  );
}
